export default __webpack_public_path__ + "static/media/barChart.d367d06c.svg";